export default __webpack_public_path__ + "static/media/manual21.381d7bfb.png";